import React from "react";
import {ConfirmModal, useNotifications} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useMutation} from "@tanstack/react-query";
import {notifyDanger, notifySuccess} from "@/utils/NotifyUtils";
import {FeaturedProductDetails} from "@/data/entities/product";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {api} from "@/data/api";

export type DeleteFeaturedProductState = {
    showModal: boolean,
    featuredProductId: number,
};

type Props = {
    show: boolean,
    setShow: (show: boolean) => void,
    featuredProductId: number,
    cb: (remainingFeaturedProducts: FeaturedProductDetails[]) => void,
};

const DeleteFeaturedProductModal = ({show, setShow, featuredProductId, cb}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const {dashboardLocation} = useRestaurant();
    const {mutate, isPending} = useMutation({
        mutationFn: (featuredProductId: number) => api.featuredProduct.deleteFeaturedProduct(dashboardLocation.id, featuredProductId),
        onSuccess: (result) => {
            cb(result);
            setShow(false);
            notifySuccess(intl.formatMessage({id: "deleted"}), notify)
        },
        onError: () => {
            notifyDanger(intl.formatMessage({id: "systemError"}), notify);
        },
    });

    return (
        <ConfirmModal
            type={"danger"}
            show={show}
            onClose={() => setShow(false)}
            title={intl.formatMessage({id: "deleteFeaturedProduct"})}
            dismissButton={{
                text: intl.formatMessage({id: "cancel"}),
            }}
            continueButton={{
                text: intl.formatMessage({id: "continue"}),
                onClick: () => mutate(featuredProductId),
                props: {color: "danger"},
            }}
            disabled={isPending}
            loading={isPending}
            position={"center-bottom"}
            breakpoints={{md: {position: "center"}}}
        >
            <FormattedMessage id={"confirmDeleteFeaturedProduct"}/>
        </ConfirmModal>
    );
};

export default DeleteFeaturedProductModal;